export const repositories = {
ConfigRS:"/api/repositories/configRS/",
AppConfigRS:"/api/repositories/appconfigRS/",
CarrierRS:"/api/repositories/carrierRS/",
ElementHelpRS:"/api/repositories/elementhelpRS/",
IM_LogObjectRS:"/api/repositories/im_logobjectRS/",
LV_AccountRS:"/api/repositories/lv_accountRS/",
LV_ADDomainRS:"/api/repositories/lv_addomainRS/",
LV_ADLocationRS:"/api/repositories/lv_adlocationRS/",
LV_CurrencyRS:"/api/repositories/lv_currencyRS/",
LV_LanguageRS:"/api/repositories/lv_languageRS/",
LV_PermissionRS:"/api/repositories/lv_permissionRS/",
LV_ShipmentAddressRS:"/api/repositories/lv_shipmentaddressRS/",
LV_ShipmentAddressStateRS:"/api/repositories/lv_shipmentaddressstateRS/",
LV_ShipmentKindRS:"/api/repositories/lv_shipmentkindRS/",
LV_ShipmentStateRS:"/api/repositories/lv_shipmentstateRS/",
LV_ShipmentTypeRS:"/api/repositories/lv_shipmenttypeRS/",
PerformanceLogRS:"/api/repositories/performancelogRS/",
PermissionGroupRS:"/api/repositories/permissiongroupRS/",
PermissionGroupUserXRefRS:"/api/repositories/permissiongroupuserxrefRS/",
PermissionGroupPermissionXRefRS:"/api/repositories/permissiongrouppermissionxrefRS/",
ShipmentPackageRS:"/api/repositories/shipmentpackageRS/",
ShipmentRS:"/api/repositories/shipmentRS/",
ShipmentRouteRS:"/api/repositories/shipmentrouteRS/",
ShipmentCarrierRS:"/api/repositories/shipmentcarrierRS/",
UserOptionsRS:"/api/repositories/useroptionsRS/",
UsersRS:"/api/repositories/usersRS/",
NumberGeneratorRS:"/api/repositories/numbergeneratorRS/",
EventLogRS:"/api/repositories/eventlogRS/",
AttachmentRS:"/api/repositories/attachmentRS/",
};